
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

try {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
} catch (err: unknown) {
  // Log the error and show a visible banner so it's obvious in the browser
  // that the React mount failed.
  console.error('REACT MOUNT ERROR:', err);
  try {
    type ErrorWithMessage = { message: string; stack?: string };
    const msg = err && typeof err === 'object' && 'message' in err 
      ? (err as ErrorWithMessage).message 
      : String(err);
    const detail = err && typeof err === 'object' && 'stack' in err 
      ? (err as ErrorWithMessage).stack || '' 
      : '';
    const errEl = document.createElement('div');
    errEl.id = '__react_mount_error';
    errEl.style.position = 'fixed';
    errEl.style.left = '8px';
    errEl.style.bottom = '48px';
    errEl.style.zIndex = '2147483647';
    errEl.style.background = '#b91c1c';
    errEl.style.color = '#fff';
    errEl.style.padding = '10px 14px';
    errEl.style.borderRadius = '8px';
    errEl.style.maxWidth = 'min(90vw, 680px)';
    errEl.style.fontSize = '13px';
    errEl.textContent = `React mount failed: ${msg}`;
    const pre = document.createElement('pre');
    pre.textContent = detail;
    pre.style.whiteSpace = 'pre-wrap';
    pre.style.maxHeight = '240px';
    pre.style.overflow = 'auto';
    pre.style.marginTop = '8px';
    pre.style.color = '#fee2e2';
    pre.style.background = 'transparent';
    errEl.appendChild(pre);
    document.body.appendChild(errEl);
  } catch {
    // ignore errors when trying to display the error
  }
}